import { render, staticRenderFns } from "./AddElementDialog.vue?vue&type=template&id=64c8cff1&"
import script from "./AddElementDialog.vue?vue&type=script&lang=ts&"
export * from "./AddElementDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports